import { Box, Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { EmergencyRoomEditFormikValues } from 'presentation/hospital/layouts/EmergencyRoom/EmergencyRoomDetails/types'
import theme from 'presentation/styles/theme'
import React, { useState } from 'react'
import { DefaultDoctorInfo } from './DefaultDoctorInfo'
import SelectDefaultDoctorModal from './SelectDefaultDoctorModal'
import { SelectUseDefaultDoctor } from './SelectUseDefaultDoctor'

export function EmergencyRoomDefaultDoctor() {
  const { values } = useFormikContext<EmergencyRoomEditFormikValues>()
  const [openModal, setOpenModal] = useState<boolean>(false)

  const renderMode = () => {
    if (
      values.useDefaultDoctor === true ||
      (values.useDefaultDoctor === false && values.doctor)
    )
      return <DefaultDoctorInfo />
    return <SelectUseDefaultDoctor setOpenModal={setOpenModal} />
  }

  return (
    <Box
      p={4}
      bgcolor={theme.colors.white}
      borderRadius={theme.border.radius.medium}
      width="100%"
    >
      <Grid container direction="column" spacing={4}>
        {renderMode()}
      </Grid>
      {openModal && (
        <SelectDefaultDoctorModal onCancel={() => setOpenModal(false)} />
      )}
    </Box>
  )
}
